module.exports = __webpack_public_path__ + "static/media/carousel.ee98c5cb.png";